import { Badge, DataList, DialogBody, HStack, Image, Spinner, Stack, Text } from "@chakra-ui/react";
import { UI } from "components";
import { Styles } from "config";
import useNetworkDownline from "hooks/useNetworkDownline";

export default function Downline({ data, ...props }){

    const downline = useNetworkDownline(data?.id)
    const careerStyle = Styles.pin(downline.data?.current_career?.id ?? data?.career_id)

    return(
    <UI.Dialog title={downline.data?.name ?? data?.name} loading={downline.isFetching} {...props}>
        <DialogBody>
            <Stack gap={4}>

                <HStack p={4} background={`${careerStyle.colorPalette}.muted`} borderRadius={4}>
                    <Image src={careerStyle.image_url} height={30} />
                    <Text fontSize="lg" fontWeight="bold">{downline.data?.current_career?.title ?? data?.career_title}</Text>
                </HStack>

                <UI.Show visible={downline.isFetching}><UI.Alert indicator={<Spinner />}>Carregando dados do downline...</UI.Alert></UI.Show>

                <UI.Alert size="sm" colorPalette="gray" title="⚠️ Dados sensíveis">
                    É expressamente proibida a cópia, download, print ou qualquer tipo de compartilhamento de dados de consultores com terceiros. 
                    O objetivo deste relatório é apenas informativo e para sua visualização.
                </UI.Alert>

                <DataList.Root orientation="horizontal">
                    <DataList.Item>
                        <DataList.ItemLabel>Nome completo:</DataList.ItemLabel>
                        <DataList.ItemValue>{downline.data?.name}</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Downlines diretos:</DataList.ItemLabel>
                        <DataList.ItemValue>{downline.data?.downlines} downlines</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Maior Pin:</DataList.ItemLabel>
                        <DataList.ItemValue><Badge>{downline.data?.higher_career?.career?.title}</Badge></DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Média investido:</DataList.ItemLabel>
                        <DataList.ItemValue><UI.Number.Amount value={downline.data?.orders_volume} /></DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>E-mail:</DataList.ItemLabel>
                        <DataList.ItemValue>{downline.data?.email}</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Telefone:</DataList.ItemLabel>
                        <DataList.ItemValue>{downline.data?.mobile}</DataList.ItemValue>
                    </DataList.Item>
                    <DataList.Item>
                        <DataList.ItemLabel>Link de indicação:</DataList.ItemLabel>
                        <DataList.ItemValue fontSize="xs" fontWeight="bold" color="orange.fg"><a href={downline.data?.indication_url} target="_blank" title={`Link de indicação de ${downline.data?.name}`}>{downline.data?.indication_url}</a></DataList.ItemValue>
                    </DataList.Item>
                </DataList.Root>

            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}